import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administracion-objetivos-edit',
  templateUrl: './administracion-objetivos-edit.component.html',
  styleUrls: ['./administracion-objetivos-edit.component.scss']
})
export class AdministracionObjetivosEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
